"use strict";
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, urls, permissions) {
  $scope.getList = function() {
    $scope.loading = true;
    var params = {
      "name": $scope.query,
      "page": $scope.page,
      "per_page": $scope.per_page
    };
    $http.get('/api/collection.json', {params: params}).success(function(data, status, headers, config) {
      $scope.collections = data.collections;
      $scope.count = data.count;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
      saveFilter(params);
    });
  };
  $scope.hasFlag = function(collection, flag) {
    var flags = collection.flags;
    if (hlp.isSet(flags) && hlp.isSet(flag)) {
      for (var i = 0; i < flags.length; i++) {
        if (flags[i] == flag) {
          return true;
        }
      }
    }
    return false;
  };
  $scope.refresh = function() {
    $scope.page = 1;
    $scope.getList();
  };
  $scope.setPage = function(page) {
    $scope.page = page;
    $scope.getList();
  };
  $scope.resetFilter = function() {
    localStorage.removeItem("collection-filter");
    initFilterDefaults();
    $scope.getList();
  };
  $scope.hasPermission = hlp.hasPermission;
  var saveFilter = function(params) {
    localStorage.setItem("collection-filter", JSON.stringify(params));
  };
  var initFilterDefaults = function() {
    $scope.per_page = 20;
    $scope.query = "";
    $scope.archivnr = "";
    $scope.page = 1;
  };
  var initFilter = function() {
    var filter = localStorage.getItem("collection-filter");
    if (filter != null) {
      var params = JSON.parse(filter);
      $scope.archivnr = params.archivnr;
      $scope.per_page = params.per_page;
      $scope.query = params.query;
      $scope.page = params.page;
    }
    var result = document.URL.match(/page=([0-9]+)/);
    if (result != null && result.length > 0 && hlp.isSet(result[1])) {
      $scope.page = parseInt(result[1]);
    }
  };
  var init = function() {
    $scope.urls = urls;
    $scope.count = 0;
    $scope.permissions = permissions;
    initFilterDefaults();
    initFilter();
    $scope.getList();
  }();
};
module.exports = controller;
